/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var GetCorrespondence = require('../../services/GetCorrespondence');
var ConSerRespondExternalCorrespondenceTaskView = require('./ConSerRespondExternalCorrespondenceTaskView');

module.exports = {
  event: 'build:cs:respond-external-correspondence',

  channel: 'task',

  builder: function(task) {
    var defer = $.Deferred();
    var correspondenceId = task.taskData.CS.csCorrespondenceId;
    var complaintId = task.taskData.CS.csComplaintId;
    var departmentName = task.taskData.CM.departmentName;

    $.when(GetCorrespondence(correspondenceId))
      .done(function(correspondence) {
        NProgress.set(0.85);
        defer.resolve(
          new ConSerRespondExternalCorrespondenceTaskView({
            model: new Backbone.Model({
              task: task,
              taskId: task.taskId,
              departmentName: departmentName,
              complaintId: complaintId,
              correspondenceId: correspondenceId,
              correspondence: correspondence
            })
          })
        );
      })
      .fail(function(err) {
        defer.reject(err);
      });
    return defer.promise();
  }
};
